import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { CategoryForm } from "./categories/CategoryForm";
import { CategoryList } from "./categories/CategoryList";

export const CategoriesManagement = () => {
  const [editingCategory, setEditingCategory] = useState<{ id: string; name: string } | null>(null);

  const { data: categories = [], isLoading, refetch } = useQuery({
    queryKey: ['admin-categories'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .order('name');
      
      if (error) {
        toast("خطأ", {
          description: error.message
        });
        throw error;
      }
      
      return data;
    },
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold">إدارة التصنيفات</h2>
      </div>

      <CategoryForm
        editingCategory={editingCategory}
        onSuccess={() => {
          setEditingCategory(null);
          refetch();
        }}
      />

      <CategoryList
        categories={categories}
        onEdit={setEditingCategory}
        onUpdate={refetch}
      />
    </div>
  );
};